import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';
import LinearProgress from '@mui/material/LinearProgress';

import SetNewPasswordPage from '@ts-core/modules/auth/pages/SetNewPasswordPage';
import { ApiClientProvider } from '@ts-core/lib/apiClient';
import { CourseProvider } from '@ts-core/context/course';

import LoginPage from 'modules/auth/pages/LoginPage';
import { useProfessorAuth } from 'modules/auth/hooks';

import ProfessorPrivateSection from 'core/pages/ProfessorPrivateSection';

const Routes = () => (
  <Switch>
    <Route component={LoginPage} path="/login" exact />
    <Route path="/set-new-password" component={SetNewPasswordPage} />
    <Route path="/:courseId" component={ProfessorPrivateSection} />
    <Redirect to="/courses" />
  </Switch>
);

const App = () => {
  const { loading, loadingUser } = useProfessorAuth();

  return (
    <ApiClientProvider apiBaseUrl="/v2/professor/">
      <CourseProvider>
        <CssBaseline />
        {loading || loadingUser ? <LinearProgress /> : <Routes />}
      </CourseProvider>
    </ApiClientProvider>
  );
};

export default App;
